import React, { useContext } from "react";

import { useImmerReducer } from "use-immer";

const initialState = {
  profile: null,
};

function actionReducer(draft, action) {
  switch (action.type) {
    case "CHANGE_FIELD":
      draft[action.field] = action.payload;
      return;
    case "LOGOUT":
      draft.profile = null;
      return;
    default:
      return;
  }
}

export const AppContext = React.createContext();
export const DispatchContext = React.createContext();

export const useApp = () => useContext(AppContext);
export const useDispatch = () => useContext(DispatchContext);

export default function AppProvider({ children, value }) {
  const [state, dispatch] = useImmerReducer(actionReducer, {
    ...initialState,
    ...value,
  });

  return (
    <DispatchContext.Provider value={dispatch}>
      <AppContext.Provider value={state}>{children}</AppContext.Provider>
    </DispatchContext.Provider>
  );
}
